import './custom-bootstrap.scss';
import './custom.scss';
import './App.css';
import React from 'react'
import { Outlet,useParams } from 'react-router-dom';
import BackgroundWaves from './SVG/BackgroundWaves';
import Nav from './Nav';
import Menu from './Shared/Menu';

export default function Layout (props) {

    const {onLogout,token} = props;
    const {affiliateId} = useParams();
    
    if (affiliateId!== undefined && affiliateId!=='home'){
      localStorage.setItem('affiliate_id', affiliateId)
    }

    return <>

    
      
      <div className='container' style={{minHeight:'70vh', maxWidth: '900px'}}>
      <Nav onLogout={onLogout}></Nav>
        <div className='bg-black' style={{
          padding: '3.2em 1.3em 1.3em 1.3em',
          borderRadius: '20px', position: 'relative', zIndex: 2
        }}>
          <div className='profile' style={{display:token===null?'none':'block',marginTop: '-1.6em'}}>

            <svg xmlns="http://www.w3.org/2000/svg" width="401px" height="401px" version="1.1" viewBox="312.809 0 401 401">
              <g transform="matrix(1.223 0 0 1.223 -467.5 -843.44)">
                <rect x="601.45" y="653.07" width="401" height="401" fill="#E4E6E7" />
                <path d="m802.38 908.08c-84.515 0-153.52 48.185-157.38 108.62h314.79c-3.87-60.44-72.9-108.62-157.41-108.62z" fill="#AEB4B7" />
                <path d="m881.37 818.86c0 46.746-35.106 84.641-78.41 84.641s-78.41-37.895-78.41-84.641 35.106-84.641 78.41-84.641c43.31 0 78.41 37.9 78.41 84.64z" fill="#AEB4B7" />
              </g>
            </svg>
          </div>


          <div className='bg-white' style={{ borderRadius: '15px', 'position': 'relative' }}>

            <Outlet />
          </div>
        </div>

      </div>

      <BackgroundWaves></BackgroundWaves>
      
      </>
  }

